<template>
  <div class="pa-2 text-center ">
    <div class="mt-12" v-if="!signedIn" >
      <h2 class="ma-4">Terminal Administration</h2>
      <amplify-authenticator  v-if="!signedIn"  :authConfig="configurationOptions">
      <div>
        Admin
        <amplify-sign-out></amplify-sign-out>
      </div>
      </amplify-authenticator>
    </div>
    <v-btn elevation="0" v-if="signedIn" color="blue-grey lighten-1" @click="signOut" class="signout white--text mb-2 float-right" >Sign <br>out</v-btn>

    <div v-if="signedIn && authenticatedToWork">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="pa-5"
      >
        <v-card-title class="px-0 pt-0">Administrator Service for {{venue}}</v-card-title>
        <v-card-subtitle  class="px-0">Add Teller Details below</v-card-subtitle>
        <v-text-field
          v-model="username"
          :counter="10"
          :rules="nameRules"
          label="Username"
          required
        ></v-text-field>

        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          required
        ></v-text-field>
        <!-- <v-text-field
          v-model="password"
          :rules="passwordRules"
          label="Temporary Password"
          required
        ></v-text-field> -->
        <v-btn elevation="0"
          :disabled="!valid"
          color="success"
          class="mr-4"
          small
          @click="signUp"
        >
          Create User
        </v-btn>
        <v-btn elevation="0"
          color="error"
          class="mr-4"
          small
          @click="reset"
        >
          Reset Form
        </v-btn>
      </v-form>
      <v-divider class="ma-4"></v-divider>
      <v-toolbar class="mb-3" height="30px" color="#425058" dark>
            <h4>Terminal Users (Tellers)</h4>
          </v-toolbar>
      <TerminalUserManagement v-if="group" :adminview="true" :venuegroup="group"/>
    </div>
    
    <v-alert type="error" v-if="signedIn && !authenticatedToWork">
      You are not authenticated to view this page, please contact administrator <br>
      <v-btn class="mt-2" @click="signOut()">Return to Login Screen</v-btn>
    </v-alert>
  </div>
</template>

<script>
import { CognitoIdentityProviderClient, AdminCreateUserCommand, AdminAddUserToGroupCommand } from "@aws-sdk/client-cognito-identity-provider";
import { fromCognitoIdentityPool  } from "@aws-sdk/credential-providers";
import { Auth } from 'aws-amplify';
import TerminalUserManagement from '../components/TerminalUserManagement.vue'
export default {
  props: {
    signedIn: Boolean,
    signOut: Function
  },
  data: () => ({
    admin: '',
    venue: '',
    group: '',
    operations: '',
    authenticatedToWork: false,
    configurationOptions: {
      signInConfig: {
        isSignUpDisplayed: false
      }
    },
    valid:false,
    emailVerify: 'SUPPRESS',
    username: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      v => (v && v.length >= 6) || 'Name must be more than 6 characters',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 6) || 'Password must be more than 6 characters',
    ]
  }),
  watch: {
    signedIn () {
      if (this.signedIn) {
        this.checkAdminVenue ()
      }
    }
  },
  components:{
    TerminalUserManagement
  },
  methods: {
    async checkAdminVenue() {
      await this.getAttributes()
      const venueCorrect = (this.venue !== '')
      const adminCorrect = (this.admin === '1')
      const groupCorrect = (this.group === this.venue)
      if ((adminCorrect && venueCorrect && groupCorrect)) this.authenticatedToWork = true
      else this.authenticatedToWork = false
    },
    async getAttributes () {
      const result = await Auth.currentUserInfo()
      const data = await Auth.currentAuthenticatedUser()
      const group = data.signInUserSession.accessToken.payload['cognito:groups'] || ''
      const mainGroup = group[0] || ''
      const venue = result.attributes['custom:venue']
      const admin = result.attributes['custom:admin']
      this.group = mainGroup
      this.venue = venue
      this.admin = admin
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    async signUp() {
      const venueSet = this.venue
      const params = {
        UserPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
        Username: this.username,
        DesiredDeliveryMediums: [
          'EMAIL'
        ],
        UserAttributes: [
          { Name: "email", Value: this.email },
          { Name: "email_verified", Value: "True" },
          { Name: "custom:venue", Value: venueSet },
        ],
        ForceAliasCreation: false,
        MessageAction: this.emailVerify,
      }
      const reg = 'ap-southeast-2'
      const config = {
        region: reg,
        credentials: fromCognitoIdentityPool ({
          // Required. The unique identifier for the identity against which credentials
          // will be issued.
          identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY,
          // Optional. The ARN of the role to be assumed when multiple roles were received in the token
          // from the identity provider.
          clientConfig: { region: reg },
        }),
      }
      const client = new CognitoIdentityProviderClient(config)
      const command = new AdminCreateUserCommand(params)
      try {
        const data = await client.send(command);
        if (data.User.Username === this.username) {
          this.emailVerify = 'RESEND'
          this.sendEmail()
        }
        // process data.
      } catch (error) {
        console.log(error)
        alert('error setting up user: ', error);
        // error handling.
      } finally {
        // finally.
      }
    },
    async sendEmail() {
      const params = {
        UserPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
        Username: this.username,
        DesiredDeliveryMediums: [
          'EMAIL'
        ],
        ForceAliasCreation: false,
        MessageAction: this.emailVerify,
      }
      const reg = 'ap-southeast-2'
      const config = {
        region: reg,
        credentials: fromCognitoIdentityPool ({
          // Required. The unique identifier for the identity against which credentials
          // will be issued.
          identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY,
          // Optional. The ARN of the role to be assumed when multiple roles were received in the token
          // from the identity provider.
          clientConfig: { region: reg },
        }),
      }
      const client = new CognitoIdentityProviderClient(config)
      const command = new AdminCreateUserCommand(params)
      try {
        const data = await client.send(command);
        if (data.User.Username === this.username) {
          this.emailVerify = 'SUPPRESS'
          alert('set up new user successful');
          this.addUserToGroup()
        }
        // process data.
      } catch (error) {
        alert('error setting up user: ', error);
        // error handling.
      } finally {
        // finally.
      }
    },
    async addUserToGroup() {
      const params = {
        UserPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
        Username: this.username,
        GroupName: this.group,
      }
      const reg = 'ap-southeast-2'
      const config = {
        region: reg,
        credentials: fromCognitoIdentityPool ({
          // Required. The unique identifier for the identity against which credentials
          // will be issued.
          identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY,
          // Optional. The ARN of the role to be assumed when multiple roles were received in the token
          // from the identity provider.
          clientConfig: { region: reg },
        }),
      }
      const client = new CognitoIdentityProviderClient(config)
      const command = new AdminAddUserToGroupCommand(params)
      try {
        await client.send(command);
        alert('User added to Venue Group', this.group);
        this.reset()
        // process data.
      } catch (error) {
        alert('error adding user to group: ', error);
        // error handling.
      } finally {
        // finally.
      }
    }
  }
}
</script>

<style>

</style>